import { Subject } from "rxjs";
import apiResponse from "../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  createChannel = new Subject();
  guideCategoryChannel = new Subject();
  employeeChannel = new Subject();
  repository = new CreateRepository();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.guideCategoryChannel.next({ status: apiResponse.INITIAL });
    this.employeeChannel.next({ status: apiResponse.INITIAL });
  }

  fetchCreate = async (query) => {
    this.createChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchCreate(query)
      .then((result) => {
        this.createChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.createChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchSearch = async (query, cancelToken, cb = null) => {
		this.employeeChannel.next({ status: apiResponse.LOADING });
		try {
			await this.repository
				.fetchSearch(query, cancelToken)
				.then((result) => {
					this.employeeChannel.next({
						status: apiResponse.COMPLETED,
						data: result,
					});
					if (cb) cb(result);
				})
				.catch((error) => {
					this.employeeChannel.next({ status: apiResponse.ERROR, data: error });
				});
		} catch (error) {}
	};
}

export default CreateBloc;
